export const VERIFY_TYPE = {
    CRC16: 1,
    CRC32: 2,
}

export function getVerifyTypeName(type: number) {
    if (type === VERIFY_TYPE.CRC16) {
        return "CRC16 校验"
    } else if (type === VERIFY_TYPE.CRC32) {
        return "CRC32 校验"
    }
    return ''
}

export const VERIFY_TYPE_LIST = [
    { value: VERIFY_TYPE.CRC16, label: 'CRC16 校验' },
    { value: VERIFY_TYPE.CRC32, label: 'CRC32 校验' },
]